import { Container, Row, Col } from 'react-bootstrap';
import { HeadingDesc } from '../Headings';
import './topicBanner.css';

function TopicBanner(props) {
  const { bgImg, img, colorHeading, title, desc } = props;

  return (
    <div className="topicBanner" style={{ backgroundImage: `url(${bgImg})` }}>
      <Container>
        <div className="banner_content_container">
          <Row>
            <Col md={5}>
              <div className="banner_inner_image">
                <img src={img} alt="banner-img" />
              </div>
            </Col>
            <Col md={6}>
              <div className="banner_text">
                <h1 className="banner_title">
                  <span>{colorHeading || ''} </span> {title || ''}
                </h1>
                <HeadingDesc text={desc || ''} />
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}

export default TopicBanner;
